import { createContext, useContext, useEffect, useState } from "react";

const DimensionContext = createContext(null);

const DimensionProvider = ({children}) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
    
        // Add event listener for window resize
        window.addEventListener("resize", handleResize);
    
        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleResize = () => {
    setWindowWidth(window.innerWidth);
    };

    return (
        <DimensionContext.Provider
            value={{windowWidth}}
        >
            {children}
        </DimensionContext.Provider>
    );
}

export default DimensionProvider;

export const useDimension = () => {
    return useContext(DimensionContext);
}